import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import MdPeople from 'react-icons/lib/md/people'
import MdCheckCircle from 'react-icons/lib/md/check-circle'
import MdAccessTime from 'react-icons/lib/md/access-time'

export default class Signers extends React.Component {
  static propTypes = {
    document: PropTypes.object
  }

  renderSigners() {
    return this.props.document.signers.map(signer => {
      return (
        <div className="row" key={signer.email}>
          <div className={styles.Signer}>{signer.name}</div>
          <div className={styles.Email}>{signer.email}</div>
        </div>
      )
    })
  }

  renderIcon(signer){
    console.log("Para redenrFeaIcon me dan", signer);
    if(signer.value){
      return(
        <MdCheckCircle size={20} style={{color: '#3cb371'}} />
      )
    } else {
      return(
        <MdAccessTime size={20} />
      )
    }
  }

  render() {
    if (this.props.document.documentStatus.status === 'personal') return null
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className="col-xs-12 col-sm-10">
              <h3 className={styles.title}>Firmantes</h3>
            </div>
            <div className="col-xs-12 col-sm-2 end-md">
              <div className={styles.icon}>
                <MdPeople size={21} />
              </div>
            </div>
          </div>
        </div>
        <div className="content">{this.renderSigners()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/Signers/index.js